import { DirectionButton } from '@/components/Button/DirectionButton'
import clsx from 'clsx'
import { useMemo } from 'react'

interface Props {
    current: number
    total: number
    onPageChange: (page: number) => void
    className?: string
    hideNumbers?: boolean
}
type Items = Array<number | 'space'>
export default function Pagination({
    current,
    total,
    onPageChange,
    className,
    hideNumbers = false,
}: Props) {
    const items: Items = useMemo(() => {
        const offset = 2
        let items: Items = []
        const max = Math.min(current + offset, total)
        for (let c = Math.max(current - offset, 1); c <= max; c++) {
            if (items.includes(c)) {
                continue
            }
            items.push(c)
        }

        const first = Number(items[0])
        if (first > 2) {
            items = [1, 'space', ...items]
        } else if (first > 1) {
            items = [1, ...items]
        }

        const lastItem = items[items.length - 1]
        const last = Number(lastItem) || total
        if (last < total - 1) {
            items.push('space')
        }
        if (!items.includes(total)) {
            items.push(total)
        }

        return items
    }, [current, total])

    return (
        <div
            className={clsx(
                'flex justify-center items-center gap-5',
                className
            )}
        >
            <DirectionButton
                direction="left"
                disabled={current === 1}
                onClick={() => onPageChange(current - 1)}
                className={hideNumbers ? 'mr-2' : 'mr-6'}
            />
            {!hideNumbers &&
                items.map((item, i) => (
                    <span
                        key={`${item}-${i}`}
                        className={clsx(
                            'text-md',
                            item !== 'space' &&
                                item !== current &&
                                'hover:cursor-pointer',
                            item === current ? 'font-bold' : 'text-gray-middle'
                        )}
                        onClick={
                            item === 'space' || current === item
                                ? undefined
                                : () => onPageChange(item)
                        }
                    >
                        {item === 'space' ? '...' : item.toString()}
                    </span>
                ))}
            <DirectionButton
                direction="right"
                disabled={current === total}
                onClick={() => onPageChange(current + 1)}
                className={hideNumbers ? 'ml-2' : 'ml-6'}
            />
        </div>
    )
}
